import gsap from 'gsap'

export function animateInItems(itemEls) {
  gsap.to(itemEls, {
    autoAlpha: 1,
    display: 'block',
    y: 0,
    ease: 'power4.easeOut',
    duration: 1,
    stagger: 0.1,
    immediateRender: false,
  })
}

export function insertIntoGrid(data, paginatedGridEl) {
  const gridEl = paginatedGridEl.querySelector('.js-grid')

  const rootEl = document.createElement('div')
  rootEl.innerHTML = data

  const loadedPaginatedGridEl = rootEl.querySelector('.js-paginated-grid')

  if (loadedPaginatedGridEl) {
    const newItemEls = loadedPaginatedGridEl.querySelectorAll('.js-grid-item')

    gsap.set(newItemEls, {
      autoAlpha: 0,
      y: 40,
    })

    Array.from(newItemEls).forEach((el) => {
      gridEl.appendChild(el)
    })

    animateInItems(newItemEls)
  }
}

export function clearGrid(gridEl) {
  if (gridEl) {
    while (gridEl.firstChild) {
      gridEl.removeChild(gridEl.firstChild)
    }
  }
}

export function removeLoadMoreContainer(paginatedGridEl) {
  const loadMoreContainerEl = paginatedGridEl.querySelector(
    '.js-paginated-grid-load-more-container'
  )

  if (loadMoreContainerEl) {
    loadMoreContainerEl.parentNode.removeChild(loadMoreContainerEl)
  }
}
